import ScriptingEffect from './ScriptingEffect.js';
import {pipe} from './pipe.js';
import {alt} from './alt.js';
import {
    switchOutput,
    execute,
    rolling,
    notes,
    steps,
    prob,
    cond
} from './lang.js';

class Roll extends ScriptingEffect {
    constructor(track) {
        super("Roll", track);
        this.clear();

        this.numberOfOutputs = 2;
    }

    get documentation() {
        return [
            "Sends triggers to output 1 when the sequence is rolling.",
            "All other triggers go to output 2."
        ];
    }

    isRealTime() {
        return false;
    }

    clear() {
        this.myScript = pipe(
            cond(rolling(), switchOutput(0), switchOutput(1)));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track, ignoreId=true) {
        let fx = new Roll(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}


export default Roll;
